(function () {
    'use strict';
    angular.module('app').factory('OfficesTableService', OfficesTableService);
    OfficesTableService.$inject = [
        'TableLiteFactory',
        'ClientService',
        '$q',
        '$timeout'
    ];
    function OfficesTableService(
        TableLiteFactory,
        ClientService,
        $q,
        $timeout
    ) {
        return function (options = {}) {
            let selectedOffices = [];
            let offices = null;
            var tableStructure = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'SELECT ALL OFFICES',
                        onClick: options.selectAll
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: true,
                    tableHeight: '30vh',
                    tableMinHeight: '30vh'
                },
                headers: [{
                    class: 'text-center',
                    width: '10%',
                    viewName: 'checkAll',
                    filter: {
                        type: 'checkbox',
                        viewnName: 'checkbox',
                        fn: function (data, isAllselected) {
                            if (data) {
                                if (data.isSelected) {
                                    let found = selectedOffices.find(val => val.id === data.id);
                                    if (!found)
                                        selectedOffices.push(data);
                                }
                                else {
                                    let index = selectedOffices.findIndex(val => val.id === data.id);
                                    selectedOffices.splice(index, 1);
                                }
                            } else {
                                if (isAllselected) {
                                    let selectedDataFrmTable = tableStructure.data.filter(val => val.isSelected);
                                    for (let i = 0; i < selectedDataFrmTable.length; i++) {
                                        let found = selectedOffices.find(val => val.id === selectedDataFrmTable[i].id);
                                        if (!found)
                                            selectedOffices.push(selectedDataFrmTable[i]);
                                    }
                                }
                                else {
                                    let tableData = tableStructure.data;
                                    for (let i = 0; i < tableData.length; i++) {
                                        let index = selectedOffices.findIndex(val => val.id === tableData[i].id);
                                        selectedOffices.splice(index, 1);
                                    }
                                }
                            }
                        }
                    }
                }, {
                    label: 'OFFICE NAME',
                    viewName: 'officeName',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'LOCATION',
                    viewName: 'officeLocation'
                }],
                data: []
            }

            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: ClientService.Location.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 5,
                        page: 0,
                        sort: 'desc',
                        active: true
                    }
                }
            );

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    row.officeName = row.name;
                    row.officeLocation = `${row.location.name}, ${row.location.country.name}`;
                    if (offices) {

                        if (row.isSelected = selected(offices.value || offices, row)) {
                            let found = selectedOffices.find(val => val.officeId === row.id || val.id === row.id);

                            if (!found)
                                selectedOffices.push(row);
                        }
                    }
                    tableStructure.data.push(row);
                });
                /*** END - Building of Data ***/
            };

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function updateData(id, selectedData) {

                if (selectedData) {
                    offices = selectedData.offices;
                }
                sendRequest({ company: id });
            }

            function selected(data, row) {
                if (data.length > 0) {
                    let foundData = data.find(val => {
                        return val.officeId == row.id || val.id == row.id;
                    });
                    return foundData ? true : false;
                }

            }

            function getSelectedOffices() {
                return tableStructure.data.filter(item => item.isSelected);
            }

            this.updateData = updateData;
            this.selectedOffices = getSelectedOffices;
            this.tableData = tableStructure;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/OfficesTableService.js